/* @ngInject */
const resizeLongueur = ($window) => {
  const resizeToFitLongueur = (element) => {
    const divHeight = element.width() / 2.16
    const height = divHeight * 0.22
    element.css('fontSize', height / 2)

    const icons = element.children('i')
    icons.css('font-size', height / 1.5)

    const onWindowResize = () => {
      const divHeight = element.width() / 2.16
      const height = divHeight * 0.22
      element.css('fontSize', height / 2)

      const icons = element.children('i')
      icons.css('font-size', height / 1.5)
    }

    $window.addEventListener('resize', onWindowResize)

    scope.$on('$destroy', () => {
      element.off()
      $window.removeEventListener('resize', onWindowResize)
    })
  }

  return {
    restrict: 'AE',
    link: (scope, element) => {
      resizeToFitLongueur(element)
    },
  }
}

export default resizeLongueur



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/styles/resizeLongueur.js